<template>
  <div
    ref="emailVerificationModal"
    class="modal modal-v modal-v--normal fade"
    id="emailVerificationModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="emailVerificationModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button type="button" class="close " data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body d-flex flex-column align-items-center justify-content-start">
          <h2 class="title title--medium mb-3 mt-5 mt-md-0">{{ trans.get('profile:edit.email_verification_modal.header') }}</h2>

          <form id="emailVerificationForm" @submit.prevent="sendForm">
            <div class="desc desc--medium text-center mb-5">
              <label for="email">{{ trans.get('profile:edit.email_verification_modal.enter_email_label') }}</label>
            </div>
            <div class="form-row mb-2">
              <div class="col">
                <input v-model="email" id="email" type="email" class="input-text__underline" name="email" required>
              </div>
            </div>
          </form>

          <ResponseComponent :response="response" errorClass="text-danger" class="text-center mb-3 desc desc--lightgrey"></ResponseComponent>

          <button
            form="emailVerificationForm"
            type="submit"
            class="button button__fill mx-auto mt-5 mb-3 js-modal-verify"
          >
            {{ trans.get('profile:edit.email_verification_modal.send_verivication_message_button') }}
          </button>

          <div class="d-flex justify-content-between align-content-center">
            <button type="button" class="button button__link mx-auto mb-3" data-dismiss="modal">{{ trans.get('profile:edit.email_verification_modal.close_button') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import HandleResponse from '../../scripts/vueHandleResponseErrors';
import ResponseComponent from '../ResponseComponent.vue';

export default {
  name: 'EmailVerificationModal',
  components: { ResponseComponent },
  mixins: [HandleResponse],
  props: {},
  data() {
    return {
      open: false,
      email: null,
      messages: null,
    };
  },
  computed: {},
  watch: {
    open(val) {
      if (val) {
        $(this.$refs.emailVerificationModal).modal('show');
      } else {
        $(this.$refs.emailVerificationModal).modal('hide');
      }
    },
  },
  methods: {
    sendForm: function () {
      this.handleResponseClear();

      this.messages = null;
      axios
        .post(zRoute('ajax.verification.email.send'), {
          email: this.email,
        })
        .then((response) => {
          this.handleResponseMessage(response.data);

          setTimeout(() => {
            this.open = false;
          }, 1000);
        })
        .catch((error) => {
          this.handleResponseErrors(error.response.data);
        });
    }
  },
  mounted() {
    this.$eventHub.$on('EmailVerificationModalOpen', () => {
      this.open = true;
    });

    $(this.$refs.emailVerificationModal).on('hidden.bs.modal', () => {
      this.open = false;
    });
  }
};
</script>

<style scoped>

</style>
